{
  "attachFile": "Прикрепить файл",
  "attachmentLimits": "До {{ MAX_FILE_SIZE_MB }} Мбайт на файл, до {{ MAX_FILES_COUNT }} файлов",
  "cancel": "Отменить",
  "dragFilesHere": "Перетащите сюда файлы, \nчтобы прикрепить их к сообщению",
  "errorRetry": "Ошибка, попробуйте еще раз",
  "fewFilesUploadFailed": "Мы не смогли загрузить некоторые файлы, удалите их и попробуйте загрузить снова",
  "fileIsTooBig": "Файл «{{ name }}» больше {{ MAX_FILE_SIZE_MB }} Мбайт. Уменьшите его или пришлите ссылку на файл в облаке.",
  "maxFileCountError": "К сообщению можно прикрепить только {{ MAX_FILES_COUNT }} файлов",
  "save": "Сохранить",
  "submit": "Отправить",
  "uploadError": "Ошибка загрузки файла по сети",
  "videoIsTooBig": "Видео «{{ name }}» больше {{ MAX_FILE_SIZE_MB }} Мбайт. Сожмите его или выложите на видеосервис и пришлите ссылку.",
  "waitUntilFilesUploaded": "Подождите пока загрузятся все файлы"
}
